import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { ShieldAlert, Lock } from "lucide-react";

export default function ForcePasswordChange() {
  const { changePassword, logout, lang } = useApp();
  const zh = lang === "zh";
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [np2, setNp2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (np.length < 8) { setErr(zh ? "新密码至少 8 位" : "At least 8 characters"); return; }
    if (np !== np2) { setErr(zh ? "两次输入的新密码不一致" : "Passwords do not match"); return; }
    if (np === cur) { setErr(zh ? "新密码不能与当前密码相同" : "New password must differ from current"); return; }
    setBusy(true);
    try {
      await changePassword(cur, np);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || (zh ? "修改失败，请检查当前密码" : "Failed, check current password"));
    }
    setBusy(false);
  };

  const field = (v, set, ph, testid) => (
    <div className="relative">
      <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
      <Input type="password" value={v} onChange={(e) => { set(e.target.value); setErr(""); }} placeholder={ph}
        data-testid={testid}
        className="pl-9 h-11 rounded-xl" />
    </div>
  );

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/45 backdrop-blur-[2px] p-4" data-testid="force-password-modal">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200/80 bg-white p-7 shadow-2xl shadow-slate-900/20">
        <div className="flex items-center gap-2 mb-1.5">
          <ShieldAlert className="h-5 w-5 text-brand-500" />
          <h3 className="text-lg font-bold text-slate-900">{zh ? "请先修改密码" : "Change your password"}</h3>
        </div>
        <p className="text-slate-500 text-sm mb-5">{zh ? "为了账号安全，需设置新密码后才能继续使用系统。" : "For security, set a new password before continuing."}</p>
        <form onSubmit={submit} className="space-y-3">
          {field(cur, setCur, zh ? "当前密码" : "Current password", "force-pw-current")}
          {field(np, setNp, zh ? "新密码（至少 8 位）" : "New password (min 8)", "force-pw-new")}
          {field(np2, setNp2, zh ? "确认新密码" : "Confirm new password", "force-pw-confirm")}
          {err && <p className="text-sm text-red-400" data-testid="force-pw-error">{err}</p>}
          <Button type="submit" disabled={busy} data-testid="force-pw-submit"
            className="w-full h-11 rounded-xl font-bold border-0">
            {busy ? (zh ? "保存中…" : "Saving…") : (zh ? "确认修改" : "Change password")}
          </Button>
          <button type="button" onClick={logout} data-testid="force-pw-logout"
            className="w-full text-center text-xs text-slate-400 hover:text-slate-700 transition-colors">
            {zh ? "退出登录" : "Log out"}
          </button>
        </form>
      </div>
    </div>
  );
}
